import React, { useCallback, useContext, useEffect, useState } from 'react';
import PageBanner from '../Usables/PageBanner';
import axios from 'axios';
import { basePath, currentDateAndTime, formatDate, getFriendlyDate, getGreeting, monthList } from '../Constants/constant';
import { AppContext } from '../ContextApi/ContextApi';
import { useNavigate } from 'react-router-dom';
import { FiBriefcase, FiSend, FiMail } from 'react-icons/fi';
import { HiOutlineCheckCircle } from 'react-icons/hi';
import { MdEventAvailable, MdDoneOutline, MdCancel, MdHighlightOff, MdPendingActions, MdUndo } from 'react-icons/md';
import { FaUserCheck, FaUserTie } from 'react-icons/fa';
import { LuListTodo } from "react-icons/lu";
import { IoAdd } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { IoIosArrowRoundForward } from "react-icons/io";
import TodoList from '../TodoList/TodoList';
import TodoForm from '../TodoList/TodoForm';
import NoRecords from '../Usables/NoRecords';
import ViewTodoInfo from '../TodoList/ViewTodoInfo';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import RefreshButton from '../Usables/RefreshButton';
import Loader from "../Usables/Loader";
import InputField from '../Usables/InputField';
import BasicButton from '../Usables/Buttons';
import WorkAllowcation from './WorkAllowcation';
import BarChart from './DashboardCharts/BarChart';
import Dropdown from '../Usables/Dropdown';
import rank1 from "../../Assets/rank1.jpg"
import rank2 from "../../Assets/rank2.jpg"
import rank3 from "../../Assets/rank3.jpg"
import LazyImage from '../Usables/LazyImage';
import { FaCrown } from "react-icons/fa";
import { PiCrownSimpleFill } from "react-icons/pi";
import SourcingChart, { DonutChart, MultiProgressBar } from './DashboardCharts/SourcingChart';
import { FaArrowTrendUp } from "react-icons/fa6";
import { FaArrowTrendDown } from "react-icons/fa6";
import DailyTask from './DailyTask';

const DashboardScreen = () => {
    const { user, apiHeaderJSON } = useContext(AppContext);
    const navigate = useNavigate();
    const [dashboardData, setDashboardData] = useState({});
    const [allJobs, setAllJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [viewTodo, setViewTodo] = useState(false);
    const [viewTodoForm, setViewTodoForm] = useState(false);
    const [dashboardAccess, setDashboardAccess] = useState(false);
    const [todoList, setTodoList] = useState([]);
    const [atsIndex, setAtsIndex] = useState(false);
    const [loadingFilter , setloadingFilter] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [usersOption, setUsersOption] = useState([]);
    const [grouppedData, setGrouppedData] = useState([]);
    const [monthYearOption, setMonthYearOption] = useState([]);
    const [showFinalJoining, setShowFinalJoining] = useState(false);
    const [selectedCandidates, setSelectedCandidates] = useState([]);
    
    const [pagination, setPagination] = useState({
        page: 1,
        totalRecords: "",
        totalPages: "",
        limit: 10,
    });
    const [ischanged, setIschanged] = useState({
        getToDoChanged: false,
        getListChanged: false,
    });

    const [filterData, setFilterData] = useState({
        fromDate: "",
        toDate: "",
        taskStatus: "",
        recruiterId:""   
    });
    const [filter, setFilter] = useState({fromDate: "", toDate: "",});
    
    const getFilterData = async () => {
        try {
            const options = {
                headers: apiHeaderJSON 
            }
            const response = await axios.get(`${basePath}/GetMonthYearFilter`, options);
            setMonthYearOption(response.data.filter_data);
            setFilter({
                month_year: response.data.filter_data[0]?.value,
                monthYear:response.data.filter_data[0]?.value,
            });
            setIschanged({ ...ischanged, getListChanged: true });
             
        } catch (error) {
            setLoading(false);
            console.error(error);
            toast.error(error?.data?.message || "Internal server error!!")
        }
    }

    // Run on component mount
    useEffect(() => {
        getFilterData();
        // currentMonthDates();
    }, []);

    const getList = useCallback(async()=> {
        try {
            const options = {
                params: {filter},
                headers: apiHeaderJSON,
            };

            const [response1] = await Promise.allSettled([
                axios.get(`${basePath}/GetDashboardData`, options),
            ]);
            if (response1.status === "fulfilled") {
                // console.log("GetDashboardData => response1", response1?.value?.data?.data);
                const recruiterList = Array.isArray(response1?.value?.data?.data?.leader_board_data) && 
                response1?.value?.data?.data?.leader_board_data?.map((item, idx)=> {
                    return {...item, src: idx === 0 ? rank1 : idx === 1 ? rank2 : rank3}
                })
                const companyData = Array.isArray(response1?.value?.data?.data?.positions_leader_board) && 
                response1?.value?.data?.data?.positions_leader_board?.map((item)=> { return item?.open_positions_count });
                const companyCategories = Array.isArray(response1?.value?.data?.data?.positions_leader_board) && 
                response1?.value?.data?.data?.positions_leader_board?.map((item)=> { return item?.Company?.company_name });
                const sourcingStatusCount = [
                    response1?.value?.data?.data?.sourcing_status_count?.Screened,
                    response1?.value?.data?.data?.sourcing_status_count?.ConfirmationPending,
                    response1?.value?.data?.data?.sourcing_status_count?.Rejected,
                ];
                // const sourcingStatusLabel = [
                //     `Screened (${response1?.value?.data?.data?.sourcing_status_count?.Screened})`,
                //     `Confirmation Pending (${response1?.value?.data?.data?.sourcing_status_count?.ConfirmationPending})`,
                //     `Rejected (${response1?.value?.data?.data?.sourcing_status_count?.Rejected})`,
                // ];
                const sourcingStatusLabel = [
                    { label: "Screened", value: response1?.value?.data?.data?.sourcing_status_count?.Screened, color: "bg-[#6e7eff]" },
                    { label: "Confirmation Pending", value: response1?.value?.data?.data?.sourcing_status_count?.ConfirmationPending, color: "bg-[#8693fc]" },
                    { label: "Rejected", value: response1?.value?.data?.data?.sourcing_status_count?.Rejected, color: "bg-[#a0aafa]" },
                ];
                const pipelineCount = [
                    { label: "Shortlisted", value: response1?.value?.data?.data?.pipeline_count?.total_cv_shortlisted, color: "bg-[#5574fa]" },
                    { label: "Interview Scheduled", value: response1?.value?.data?.data?.pipeline_count?.total_cv_interview_scheduled, color: "bg-[#5563fa]" },
                    { label: "Rejected Post Interview", value: response1?.value?.data?.data?.pipeline_count?.total_cv_rejected_post_interview, color: "bg-[#6371ff]" },
                    { label: "Final Selection", value: response1?.value?.data?.data?.pipeline_count?.total_cv_final_selection, color: "bg-[#828dff]" },
                ];
                // console.log("GetDashboardData => data", data);
                // console.log("GetDashboardData => recruiterList", recruiterList);
                // console.log("GetDashboardData => sourcingStatusCount", sourcingStatusCount);
                let counter = [
                    {name: "Open Jobs", note:"", count: response1?.value?.data?.data?.total_open_positions || 0, element: <FiBriefcase className=' text-2xl text-lime-600' />, diff_note:'', fromDate:response1?.value?.data?.data?.fromDate, toDate:response1?.value?.data?.data?.toDate},
                    {name: "Sourced Candidate", note:"", count: response1?.value?.data?.data?.total_candidate_sourced || 0, element: "", diff_note:response1?.value?.data?.data?.sourcing_difference, fromDate:response1?.value?.data?.data?.fromDate, toDate:response1?.value?.data?.data?.toDate},
                    {name: "Final Selected", note:"", count: response1?.value?.data?.data?.total_selection || 0, element: "", diff_note:response1?.value?.data?.data?.selection_difference, fromDate:response1?.value?.data?.data?.fromDate, toDate:response1?.value?.data?.data?.toDate},
                    {name: "Interview Schedule", note:"Next 7 days", count: response1?.value?.data?.data?.interview_in_next_7_days_count || 0, element: "", diff_note:response1?.value?.data?.data?.interview_difference, fromDate:response1?.value?.data?.data?.fromDate, toDate:response1?.value?.data?.data?.toDate},
                ];
                
                setDashboardData({
                    ...dashboardData,
                    counter,
                    pipeline_count : pipelineCount,
                    recruiter_ranking: recruiterList,
                    interview_data: response1?.value?.data?.data?.interview_data,
                    company_ranking: {
                        series: [{ data: companyData }],
                        options: {
                            chart: { type: 'bar', height: 100, width: '100%'},
                            labels: companyCategories,
                            plotOptions: {
                                bar: {
                                borderRadius: 1,
                                borderRadiusApplication: 'end',
                                horizontal: true,
                                },
                            },
                            colors: ["#6e7eff"],
                            dataLabels: {
                                enabled: true,
                                style: { colors: ['#e6e6e6'] },
                            },
                            xaxis: {
                                categories: companyCategories,
                            },
                        },
                    },
                    sourcing_status: {
                        series: sourcingStatusCount,
                        labels: sourcingStatusLabel, 
                        options: {
                            chart: { type: "donut", width: "100%" },
                            labels: sourcingStatusLabel?.map((item)=> item?.label),
                            colors: ["#6e7eff", "#8693fc", "#a0aafa"],
                            dataLabels: { enabled: false },
                            legend: { show: false },
                            plotOptions: {
                            pie: {
                                donut: {
                                size: "50%",
                                },
                            },
                            },
                        },
                    }

                });
                setSelectedCandidates(response1?.value?.data?.data?.selected_candidates);
            } else {
                toast.error(response1.reason?.message || "Internal server error!!")
                console.log("Recruiter API failed:", response1.reason);
            }
            // setDashboardData({...dashboard});
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log("Unexpected error:", error);
        }
    },[apiHeaderJSON, filter]);
    // console.log("dashboardData", dashboardData);
    // const getList = useCallback(async () => {
    //     try {
    //         const options = {
    //             params: {
    //                 filter: JSON.stringify(filter)
    //             },
    //             headers: apiHeaderJSON,
    //         };

    //         const response = await axios.get(`${basePath}/GetDashboardData`, options);

    //         if (response.status === 200) {
    //             const data = response?.data?.data?.leader_board_data?.map((item)=> { return item?.score });
    //             const categories = response?.data?.data?.leader_board_data?.map((item)=> { return item?.recruiterName });
    //             console.log("GetDashboardData => data", data);
    //             const counter = [
    //                 {name: "Open Jobs", count: response?.data?.data?.total_open_positions, element: <FiBriefcase className=' text-2xl text-lime-600' /> },
    //                 {name: "Sourced Candidate", count: response?.data?.data?.total_candidate_sourced, element: ""},
    //                 {name: "Final Selected", count: response?.data?.data?.total_open_positions, element: ""},
    //                 {name: "Interview Schedule", count: response?.data?.data?.interview_in_next_7_days_count, element: ""},
    //             ]
    //             setDashboardData({
    //                ...dashboardData,
    //                counter,
    //                 recruiter_ranking: { 
    //                     series: [{data}], 
    //                     options: { chart: { type: 'bar', height: 350 }, 
    //                     plotOptions: { 
    //                         bar: { borderRadius: 1, 
    //                             borderRadiusApplication: 'end', 
    //                             horizontal: true, } }, 
    //                             colors: ['#a2d959'],
    //                             dataLabels: {
    //                             enabled: true,
    //                             style: {colors: ['#000000']}},
    //                             xaxis: { 
    //                                 categories, 
    //                             } 
    //                         }, 
    //                     }
    //             });
    //         } else {
    //             toast.error(response?.data?.message || 'Something went wrong');
    //         }
    //         setLoading(false);
    //     } catch (error) {
    //         setLoading(false);
    //         console.log('getTodoList error ==>', error);
    //         toast.error(error.response?.message || 'Network error! Please try again.');
    //     }
    // }, [apiHeaderJSON, filter]);

    // Function to set start and end of current month
    const currentMonthDates = () => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    let monthYear;
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        // console.log("month", month);
        monthYear = parseInt(month);
        return `${year}-${month}-${day}`;
    };

    // console.log(formatDate(startOfMonth)); 
    // console.log(formatDate(endOfMonth)); 
    formatDate(startOfMonth);
    const currentYear = new Date().getFullYear();
    let month_year_value = `${monthYear.toString().padStart(2, "0")}-${currentYear}`;

    setFilter({
        month_year: monthYear.toString().padStart(2, "0"),
        monthYear:month_year_value,
        fromDate: formatDate(startOfMonth),
        toDate: formatDate(endOfMonth),
    });
    // console.log("monthYear", monthYear);
    setIschanged({ ...ischanged, getListChanged: true });
    };

    useEffect(() => {
       if (ischanged?.getListChanged) {
        getList();
        setIschanged({...ischanged, getListChanged: false});
    }
    }, [ischanged?.getListChanged]);


    useEffect(()=>{
    let access = user?.filter((val, idx) => {
        if (val?.Module?.module_name === "ATS Pipeline") {
            setAtsIndex(idx);
            return val;
        }
    });
    // console.log("access====>>>>",access);
    setDashboardAccess(access);
    },[user]);
    const handleNavigate = ()=> {
        navigate("")
    } 
    const handleClose = (e)=> {
        setViewTodo(false);
        setFilterData({fromDate: "",
        toDate: "", taskStatus: "", recruiterId:"" });
        setPagination({page: 1, totalRecords: "", totalPages: "", limit: 10});
        setIschanged({...ischanged, getToDoChanged: true});
    };

    const handleChange = useCallback((event)=> {
        const {name, value} = event?.target;
        let updatedFilter = { ...filter, [name]: value };
        console.log("name", name, value)

        if (name === "month_year") {
            const currentYear = new Date().getFullYear();
            let month_year_value = `${value}-${currentYear}`;

            updatedFilter = {
            ...updatedFilter,
            monthYear: month_year_value,
            };
            
            setFilter(updatedFilter);
            setIschanged({...ischanged, getListChanged: true});
        }
        else {
            setFilter({...filter, [name]: value});
        }

    },[filter]);

    const handleChangeFilter = useCallback((event)=> {
            const {name, value} = event?.target;
            // console.log("name, value", name, value);
            setFilterData({ ...filterData, [name]: value, });   
    },[filterData]);

    const handleClear = useCallback(()=> {
        // setLoadingFilter("2");
        setFilterData({
            fromDate: "",
            toDate: "",  
        });
        setIschanged({...ischanged, getToDoChanged:true});
    },[ischanged]);

    const handleClearStatus = useCallback(()=> {
        setLoading("4");
        currentMonthDates();
    },[ischanged]);

    // const handleFilter = useCallback(()=>{ 
    //     getTodoList();
    // },[getTodoList]);

    const handleFilterStatus = useCallback(()=>{ 
        setLoading("3");
        getList();
    },[getList]);

    const getUserData = async () => {
            let options = {
            headers:apiHeaderJSON
        }
        let response = await axios.get(`${basePath}/getRecruiter`, options);
        // console.log(response.data);
        const recruiterList = response?.data?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        const listFilter = response?.data?.filter((val)=>{
            if(val?.activated === 1) return  val;
        });
        const activeList = listFilter?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        setAllUsers(recruiterList);
        setUsersOption(activeList);
    };

    const handleRefresh = () => {
        // console.log("loading || loadingFilter",loading, loadingFilter)
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }


    // const index = user.findIndex(item => item.Module.module_url == 'all-posted-jobs');
    // console.log(`index of all-posted-jobs =======>`, index)

    const routes = {
        'Open Jobs': `/all-posted-jobs/${user.findIndex(item => item?.Module?.module_url == 'all-posted-jobs')}`,
        'Sourced Candidate': '/sourced-candidate',
        'Final Selected': `/ats-pipeline/${user.findIndex(item => item?.Module?.module_url == 'ats-pipeline')}`,
        'Interview Schedule':`/interview-schedule/${user.findIndex(item => item?.Module?.module_url == 'interview-schedule')}`
    };
    
    const handleNavigateCounter = async (section) => {
        const path = routes[section.name];

        if (!path) return;

        const params = new URLSearchParams({
            fromDate : section.fromDate,
            toDate : section.toDate,
            candidateStatus: section.name == 'Final Selected' ? "Final Selection" : '',
        });

        if(section.name == 'Final Selected'){
            setShowFinalJoining(true);
        }else{
            navigate(`${path}?${ section.name === 'Interview Schedule' ? "" : params.toString()}`);
        }

    };

    if (loading === "1") {
        return (
            <section className=' bg-white h-[95dvh] grayBlurShadow rounded-xl mt-0.5 w-full flex justify-center items-center'>
                Loading...
            </section>
        )
    }
    
      function CounterItem({ item }) {
        const [value, setValue] = useState(0);

        useEffect(() => {
            let start = 0;
            const end = item.count;
            if (start === end) return;

            let incrementTime = 20; // ms
            let step = Math.ceil(end / 50); // smooth steps

            const timer = setInterval(() => {
            start += step;
            if (start >= end) {
                start = end;
                clearInterval(timer);
            }
            setValue(start);
            }, incrementTime);

            return () => clearInterval(timer);
        }, [item.count]);

        return (
            <div className='bg-white grayBlurShadow rounded-lg px-4 py-4 relative '>
                <div className='flex items-center gap-3'>{item?.element} 
                    <span className='text-xl text-left'>{item?.name} {item?.note && <span className=' text-muted text-xs'>({item?.note})</span>}</span>
                </div>
                <h6 className={`font-semibold text-5xl text-left cursor-pointer`} onClick={() => handleNavigateCounter(item)}>{value}</h6>
                {/* Diff Note */}
                {item?.diff_note && (
                <div className={`mt-2 absolute bottom-2 right-2 inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium  ${item?.diff_note > 0 ? 'text-green-700 bg-green-100' :'text-red-700 bg-red-100'}`}>
                    {item?.diff_note > 0 ? (
                    <FaArrowTrendUp/>
                    ) : (
                     <FaArrowTrendDown/>
                    )}
                    <span>{item?.diff_note}%</span>
                </div>
                )}
            </div>
        );
    }
console.log(`filter?.monthYear ===>`, filter?.monthYear);
    return (
        <section className=' rounded-lg p-3'>
            {showFinalJoining && (
                <FinalJoiningModal
                    candidates={selectedCandidates}
                    onClose={() => setShowFinalJoining(false)}
                />
            )}
            {/* PageBanner => used to show page banner info */}
            <div className='bg-white grayBlurShadow px-10 py-3 mb-3 rounded-lg flex justify-between items-center'>
                <h6 className=' text-2xl font-semibold'>{`Hii, ${localStorage.getItem("name")}`}</h6>
                <div className=' w-[10dvw]'>
                <Dropdown id="month_year" name="month_year"
                    onChange={handleChange}
                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                    disabled={loading}
                    placeholder={`Month`}
                    value={filter?.month_year}
                    options={monthYearOption}
                    // options={monthList}
                />
                </div>
            </div>
            {/* <PageBanner pageName={`Hii, ${localStorage.getItem("name")}`} pageTitle={`${getGreeting()}!`} src='/img/homeImg.png' alt="all jobs" /> */}
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            {/* cards */}
            <div className='grid lg:grid-cols-4 md:grid-cols-2 gap-2 mb-2'>
                {dashboardData?.counter?.map((item, index)=> {
                    return (
                        <CounterItem key={index} item={item} />
                    )
                })}
                
            </div>
            <div className='grid grid-cols-2 gap-2'>
                <div className=' bg-white grayBlurShadow rounded-lg p-2'>
                    <h6 className=' text-left text-xl pb-3 font-semibold'>Recruiter LeaderBoard</h6>
                    {Array.isArray(dashboardData?.recruiter_ranking) && dashboardData?.recruiter_ranking?.length > 0 ? 
                        <div className='flex flex-col gap-3 px-3 mt-2'>
                            {dashboardData?.recruiter_ranking?.map((item)=> {
                                return (
                                    <div className='grayBlurShadow rounded-lg py-3'>
                                        <div className='flex gap-0 px-2'>
                                            <LazyImage src={item?.src} className='w-12 mx-2' />
                                            <div>
                                                <h6 className='text-left font-semibold text-xl'>{item?.recruiterName}</h6>
                                                <p className=' text-gray-500'>Sent To Client: {item?.sentCount} | Shortlisted: {item?.shortlistCount} | <span className=' text-black'>Score: {item?.score}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        :
                       <NoRecords/>
                    }
                </div>
                <div className=' bg-white grayBlurShadow rounded-lg  p-2'>
                    <h6 className=' text-left text-xl font-semibold'>Company Positions</h6>
                    <div className='h-[40dvh] w-full overflow-hidden'>
                        {Array.isArray(dashboardData?.company_ranking?.series[0]?.data) && dashboardData?.company_ranking?.series[0]?.data?.length > 0 ? (
                            <BarChart series={dashboardData?.company_ranking?.series} options={dashboardData?.company_ranking?.options} /> 
                        ) : (
                            <NoRecords/>
                        )}
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-2 gap-2 mt-2'>
                <div className=' bg-white grayBlurShadow rounded-lg p-2'>
                    <h6 className=' text-left text-xl pb-3 font-semibold'>Interview Details</h6>
                        {Array.isArray(dashboardData?.pipeline_count) && dashboardData?.pipeline_count?.length > 0 ? 
                            <MultiProgressBar segments={dashboardData?.pipeline_count} monthYear = {filter?.monthYear} /> :
                            <NoRecords/>
                        }
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div className=' bg-white grayBlurShadow rounded-lg p-2'>
                        <h6 className=' text-left text-xl pb-3 font-semibold'>Sourcing Details</h6>
                        {Array.isArray(dashboardData?.sourcing_status?.series) && dashboardData?.sourcing_status?.series?.length > 0 ? (
                            <div className='grid grid-cols-2'>
                                <DonutChart series={dashboardData?.sourcing_status?.series} options={dashboardData?.sourcing_status?.options}  />
                                <div className=' flex flex-col justify-center'>
                                    {Array.isArray(dashboardData?.sourcing_status?.labels) && dashboardData?.sourcing_status?.labels?.length > 0 ? 
                                    dashboardData?.sourcing_status?.labels?.map((item)=> {
                                        return (
                                            <div className=' flex items-center gap-1'>
                                                <div className={`w-3 h-3 rounded-lg ${item?.color}`} />
                                                <h6 className="truncate max-w-[80px]">{item?.label}</h6>
                                                <h6>({item?.value})</h6>
                                            </div>
                                        )
                                    }) : null
                                }
                                </div>
                            </div>
                        ) : (
                            <NoRecords/>
                        )}
                    </div>
                    <div className="bg-white grayBlurShadow rounded-lg p-2">
                    <h6 className="text-left text-xl pb-2 font-semibold">Interview Schedule <span className=' text-muted text-xs'>(Next 7 Days)</span></h6>

                    {Array.isArray(dashboardData?.interview_data) && dashboardData?.interview_data?.length > 0 ? (
                        <div className="relative pl-2 flex flex-col gap-2 overflow-auto max-h-40 scrollbar-hide">
                            {dashboardData?.interview_data?.map((interview, index) => (
                                <div key={index} className="relative flex gap-3 items-start"> 
                                <div className={`absolute -left-2 top-3 w-3 h-3 rounded-full ${index % 2 === 0 ? "bg-green-500" : "bg-blue-500"}`}></div> 
                                <div className="w-20 text-sm text-gray-500 font-medium">
                                    {new Date(`${interview.interview_date} ${interview.interview_time}`).toLocaleTimeString("en-IN", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    })}
                                    <p className="text-xs text-gray-600">{new Date(interview.interview_date).toLocaleDateString("en-IN", {
                                    weekday: "short",
                                    month: "short",
                                    day: "numeric",
                                    })}</p>
                                </div> 
                                <div className={`flex-1 rounded-lg px-2 py-1 ${index % 2 === 0 ? "bg-green-100" : "bg-blue-100"}`}>
                                    <h2 className="text-sm font-semibold truncate max-w-[120px] text-left">{interview?.Candidate?.candidate}</h2>
                                    <p className="text-xs text-gray-600 truncate max-w-[120px] text-left">{interview?.Candidate?.Position?.position}</p>
                                </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <NoRecords />
                    )}
                    </div>

                </div>
            </div>
            {(localStorage.getItem("role") === "Super Admin" || localStorage.getItem("role") === "Management") && (
                <WorkAllowcation/>
            )}
            {localStorage.getItem("role") === "Management" ? null : (
                <DailyTask/>
            )}

        </section>
    );
}


const FinalJoiningModal = ({ candidates = [], onClose }) => {
    return (
       <div className="fixed inset-0 z-20 flex items-center justify-center bg-black/30">
            <div className="relative bg-white mx-5 p-5 rounded-lg w-[90%] max-w-6xl max-h-[100vh] overflow-y-auto">

                {/* Modal Header */}
                <div className="flex justify-between items-center mb-5">
                    <h2 className="text-xl font-semibold text-gray-800">
                        Final Joining
                    </h2>

                    <button
                        onClick={onClose}
                        className="cursor-pointer w-8 h-8 rounded-full bg-red-600 hover:bg-red-700 flex items-center justify-center font-semibold text-white transition-colors"
                    >
                        ✕
                    </button>
                </div>

                {/* Table */}
                <div className="border border-gray-200 rounded-xl overflow-hidden">

                    <div className="max-h-[380px] overflow-y-auto overflow-x-hidden">

                        <table className="w-full table-fixed border-collapse">

                            {/* Control Column Widths */}
                            <colgroup>
                                <col className="w-[8%]" />   {/* Sr. No. */}
                                <col className="w-[17%]" />  {/* Sent Date */}
                                <col className="w-[23%]" />  {/* Candidate */}
                                <col className="w-[38%]" />  {/* Position */}
                                <col className="w-[20%]" />  {/* Status */}
                            </colgroup>

                            {/* Sticky Header */}
                            <thead className="sticky top-0 z-10 bg-[#e5e7eb] text-[#243b5a] shadow-sm">
                                <tr>
                                    <th className="px-2 py-4 text-center font-semibold">
                                        Sr. No.
                                    </th>

                                    <th className="px-3 py-4 text-center font-semibold">
                                        Sent Date
                                    </th>

                                    <th className="px-3 py-4 text-center font-semibold">
                                        Candidate
                                    </th>

                                    <th className="px-3 py-4 text-center font-semibold">
                                        Position
                                    </th>

                                    <th className="px-3 py-4 text-center font-semibold">
                                        Current Status
                                    </th>
                                </tr>
                            </thead>

                            <tbody className="bg-white">
                                {candidates.length > 0 ? (
                                    candidates.map((candidate, index) => (
                                        <tr
                                            key={candidate.id || index}
                                            className="border-b border-gray-200 hover:bg-gray-50"
                                        >
                                            {/* Sr No */}
                                            <td className="px-1 py-4 text-center font-medium text-gray-800">
                                                {index + 1}
                                            </td>

                                            {/* Sent Date */}
                                            <td className="px-3 py-4">
                                                <div className="text-gray-800 font-semibold">
                                                    {candidate?.sent_to_client_date ? formatDate(candidate?.sent_to_client_date) : "--"}
                                                </div>

                                                <div className="text-green-600 font-semibold mt-1 text-sm break-words">
                                                    {candidate?.User?.name}
                                                </div>
                                            </td>

                                            {/* Candidate */}
                                            <td className="px-3 py-4">
                                                <div className="text-[#294c8f] font-semibold break-words">
                                                    {candidate?.candidate}
                                                </div>

                                                <div className="text-gray-400 text-sm mt-1 break-all">
                                                    {candidate?.candidate_email}
                                                </div>
                                            </td>

                                            {/* Position */}
                                            <td className="px-3 py-4">
                                                <div className="text-gray-800 font-semibold break-words">
                                                    {candidate?.Position?.Company?.company_name}
                                                </div>

                                                <div className="text-gray-400 text-sm font-medium mt-1 break-words">
                                                    {candidate?.Position?.position}
                                                </div>
                                            </td>

                                            {/* Status */}
                                            <td className="px-3 py-4 text-center">
                                                <span className="inline-flex px-3 py-2 rounded-xl text-sm font-semibold bg-green-100 text-green-600 border border-green-200">
                                                    {candidate?.candidate_status}
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={5}
                                            className="text-center py-10 text-gray-400"
                                        >
                                            No candidates found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default DashboardScreen;
